
































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import {
  AddressDto,
  BasketApi,
  BasketDto,
  ImageDto,
  OrderApi,
  OrderConfirmationDto,
  PaymentMethodDto,
  StripePaymentInformationDto
} from "@swagger";
import ImagePreview from "@/components/ImagePreview.vue";
import AddressInput from "@/components/basket/AddressInput.vue";
import CardPayment from "@/components/basket/CardPayment.vue";
import SOFORTPayment from "@/components/basket/SOFORTPayment.vue";
import BasketSummaryTable from "@/components/basket/BasketSummaryTable.vue";
import BasicComponent from "@/global/BasicComponent";
import DiscountBanner from "@/components/DiscountBanner.vue";
import PaymentMethodSelector from "@/components/PaymentMethodSelector.vue";
import {Stripe} from "@stripe/stripe-js";
import {Watch} from "vue-property-decorator";
import CountryEnum = AddressDto.CountryEnum;

@Component({
  components: {
    PaymentMethodSelector,
    DiscountBanner, SOFORTPayment, CardPayment, AddressInput, ImagePreview, BasketSummaryTable
  }
})
export default class BasketSummary extends BasicComponent {

  paymentDataValid = false;
  paymentMethod: PaymentMethodDto|null = null;

  headers: string[] = [];
  amounts: Record<number, number> = {};
  isCheckout: boolean = false;
  deliveryAddress: AddressDto = {
    firstName: "",
    lastName: "",
    street: "",
    houseNumber: "",
    postalCode: undefined,
    city: "",
    country: CountryEnum.AUSTRIA,
    institution: undefined,
  };
  email: string = "";
  email2: string = "";
  phone: string = "";
  hasComment: boolean = false;
  comment: string = "";
  checkoutStarted: boolean = false;
  dataValid: boolean = false;
  error: string | null = null;
  paymentError: string | null = null;
  paymentLoading: boolean = false;
  paymentFailed: boolean = false;
  formValid: boolean = false;
  cardError: string | null = null;
  tosAccepted: boolean = false;
  newsletter: boolean = false;

  created() {
    this.headers = [this.$t("BASKET_HEADER_PRODUCT").toString(), this.$t("BASKET_HEADER_PICTURE").toString(), this.$t("BASKET_HEADER_AMOUNT").toString(), "", this.$t("BASKET_HEADER_SUM").toString()];
  }

  mounted() {
    this.getBasketData();
    this.loadDataFromCookies();
    this.checkIfNewsletterAccepted((value) => {
    });
    this.trackPage("Warenkorb");
    this.trackEvent("Warenkorb", "Geöffnet");
  }

  get basketPositions() {
    let ret = this.basket.positions;
    return ret;
  }

  get basket(): BasketDto {
    if (!this.$store.getters.basket) {
      return {
        positions: []
      }
    }
    return this.$store.getters.basket;
  }

  get totalAmount() {
    return this.convertPriceForStripe(this.basket.totalPrice);
  }

  get needsPayment() {
    return this.basket.totalPrice > 0;
  }

  get stripe(): Stripe {
    return this.$store.getters.stripe;
  }

  getProduct(id) {
    const product = this.$store.getters.product(id);
    return product ? product : {};
  }

  getImage(uniqueId) {
    return this.$store.getters.imageById(uniqueId);
  }

  sortImages(images: Array<ImageDto>): Array<ImageDto> {
    const order = {
      SINGLE: 0,
      FRIEND: 1,
      GROUP: 2
    };
    return images.sort((a, b) => order[a.type] - order[b.type])
  }

  setStepInBasket(step) {
    this.saveDataToCookies();
    this.setStep(step, true);
    this.$router.push("/");
  }

  increaseAmount(position) {
    this.amounts[position.id]++;
    this.onAmountChange(position);
  }

  decreaseAmount(position) {
    if (this.amounts[position.id] === 0) return;
    this.amounts[position.id]--;
    this.onAmountChange(position);
  }

  deletePosition(position) {
    this.deleteBasketPosition(position.id, () => {
    }, (error) => {
    })
  }

  onAmountChange(position) {
    const oldAmount = position.amount;
    const newAmount = Number(this.amounts[position.id]);
    if (isNaN(newAmount)) {
      Vue.nextTick(() => { // Reset
        this.$set(this.amounts, position.id, oldAmount);
      });
    } else {
      position.amount = newAmount;
      this.editBasketPositionAmount(position.id, newAmount,
          () => {

          },
          (error) => {

          })
    }
  }

  onShippingMethodChange(id) {
    new BasketApi(this.apiConfiguration).changeShippingMethod({
      shippingMethodId: id
    }).then((data: BasketDto) => {
      this.$store.commit("setBasket", data);
    })
        .catch((err) => {
          if (err.json) {
            err.json().then(e => {
              this.error = e.message;
            });
          } else {
            this.error = err;
          }
        });
  }

  get maySubmitOrder() {
    if (this.paymentLoading) return false;
    return this.isDataValid;
  }

  checkout() {
    this.checkoutStarted = true;
  }

  openCheckout() {
    this.isCheckout = true;
    this.trackEvent("Warenkorb", "Zur Zahlung")

    if (this.needsPayment) {
      new OrderApi(this.apiConfiguration).getPaymentIntent()
          .then((data: StripePaymentInformationDto) => {
            this.$store.commit("setPaymentInformation", data);
          })
          .catch((err) => {
            if (err.json) err.json().then(error => {
              console.error(error)
            });
            else console.error(err);
          });
    }
  }

  get shippingData() {
    let line1 = this.deliveryAddress.street;
    const houseNumber = this.deliveryAddress.houseNumber;
    if (houseNumber !== line1) line1 += " " + houseNumber;
    return {
      name: `${this.deliveryAddress.firstName} ${this.deliveryAddress.lastName}`,
      address: {
        line1: line1,
        postal_code: this.deliveryAddress.postalCode,
        city: this.deliveryAddress.city,
        country: this.deliveryAddress.country,
        institution: this.deliveryAddress.institution,
      }
    }
  }

  get isDataValid() {
    if (!this.formValid) return false;
    if (this.needsPayment && !this.paymentDataValid) return false;
    /*
    if (this.needsPayment && !this.paymentMethod) return false;
    if (this.paymentMethod === "CREDIT_CARD") {
      if (!this.$refs.creditCardProvider["isDetailsValid"]) return false;
    }
     */
    //if (this.errors) return false;
    return true;
    //return (this.$refs.dataForm as Vue & { validate: () => boolean }).validate() && !this.errors;
  }

  get paymentIntentSecret() {
    if (!this.$store.getters.paymentInformation) return;
    return this.$store.getters.paymentInformation.paymentIntentSecret;
  }

  get errors() {
    return this.error || this.paymentError;
  }

  getFirstErrorMessage() {
    const form = this.$refs.dataForm;
    if (!form) return null;
    for (let input of form["inputs"]) {
      if (input["errorBucket"].length > 0) {
        return `${input.label}: ${input["errorBucket"][0]}`;
      }
    }
    if (!this.paymentDataValid) return this.$t('CHECKOUT_ERROR_SELECT_PAYMENT_METHOD');
    /*if (this.paymentMethod === "CREDIT_CARD") {
      if (!this.$refs.creditCardProvider["isDetailsValid"]) {
        const error = this.$refs.creditCardProvider["getError"];
        if (error) return error;
        return this.$t('CHECKOUT_ERROR_ENTER_CREDIT_CARD_DETAILS');
      }
    }*/
  }

  onPaymentError(error) {
    this.paymentError = error;
    this.paymentLoading = false;
  }

  placeOrder(evt: Event) {
    evt?.preventDefault();
    if (!this.isDataValid) return;
    this.saveDataToCookies();

    this.paymentLoading = true;
    this.error = null;
    this.paymentError = null;

    /*
    const paymentMethod = this.paymentMethod;
    let paymentProvider = null;

    if (paymentMethod === "CREDIT_CARD") {
      paymentProvider = this.$refs.creditCardProvider;
    } else if (paymentMethod === "SOFORT") {
      paymentProvider = this.$refs.sofortProvider;
    }
     */
    /*
    if (this.needsPayment && paymentProvider == null) {
      this.paymentLoading = false;
      this.paymentError = "Bitte wählen Sie eine Zahlungsart aus";
      return;
    }
     */
    new OrderApi(this.apiConfiguration).placeOrder({
      deliveryAddress: this.deliveryAddress,
      email: this.email.trim(),
      phone: this.phone,
      comment: this.comment,
      newsletterConsent: this.newsletter,
      paymentMethod: this.paymentMethod,
    })
        .then((data: OrderConfirmationDto) => {
          try {
            this.trackEvent("Warenkorb", "Bestellung abschicken", undefined, data.totalAmount);
          } catch (e) {
            console.error(e);
          }
          const bankTransfer = this.paymentMethod === PaymentMethodDto.BANKTRANSFER;
          if (bankTransfer || ! this.needsPayment) {
            window.location.replace(`${window.location.origin}/verifyPayment/${data.orderToken}?payManually=true`);
          } else {
            this.stripe.confirmPayment({
              elements: (this.$refs.paymentMethodSelector as PaymentMethodSelector).elements,
              confirmParams: {
                return_url: data.redirectUrl,
              }
            }).then(({error}) => {
              if (error) {
                const url = new URL(data.redirectUrl);
                url.searchParams.set("error", error.message);
                window.location.href = url.href;
              }
            })
          }
        })
        .catch((err) => {
          this.paymentLoading = false;
          this.paymentFailed = true;
          if (err.json) {
            err.json().then(e => {
              this.error = e.message;
            });
          } else {
            this.error = err;
          }
        });
  }

  saveDataToCookies() {
    const duration = 30;
    this["$cookie"].set("address", JSON.stringify(this.deliveryAddress), duration);
    this["$cookie"].set("email", this.email);
    this["$cookie"].set("email2", this.email2);
    this["$cookie"].set("phone", this.phone);
    this["$cookie"].set("comment", this.comment);
  }

  loadDataFromCookies() {
    const email = this["$cookie"].get("email");
    if (email) this.email = email;
    const email2 = this["$cookie"].get("email2");
    if (email2) this.email2 = email2;
    const phone = this["$cookie"].get("phone");
    if (phone) this.phone = phone;
    const comment = this["$cookie"].get("comment");
    if (comment) this.comment = comment;
    const address = this["$cookie"].get("address");
    if (address) this.deliveryAddress = JSON.parse(address);
  }

  @Watch("basket.positions")
  onPositionsChange() {
    for (let position of this.basket.positions) {
      this.$set(this.amounts, position.id, position.amount)
      this.sortImages(position.product.images);
    }
  }

}
